import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "../../app/store";
import { HttpResponse } from "../../api/observeApi";
import { setOffset } from "./listWarningsSlice";
import { obsApi } from "api";

export const fetchWarnings = createAsyncThunk(
  "warnings/fetchWarnings",
  async (withReplace: boolean, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const offset = state.listWarnings.offset;
    const filters = state.listWarnings.filters;
    return obsApi.warnings
      .listWarnings({
        offset: offset,
        filters: filters,
      })
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        if (res.error.code === 404) {
          return [];
        }
        return rejectWithValue(res);
      });
  },
);

export const deleteWarning = createAsyncThunk(
  "warnings/deleteWarning",
  async (id: string, { rejectWithValue, getState }) => {
    return obsApi.warnings
      .deleteWarning(id)
      .then((res) => {
        return;
      })
      .catch(async (res: HttpResponse<void, Error>) => {
        const err = (await res.json()) as Error;
        return rejectWithValue(err);
      });
  },
);

export const reloadRows = (): AppThunk => (dispatch, getState) => {
  dispatch(setOffset(0));
  dispatch(fetchWarnings(true));
};
